<template>
  <v-btn
    :color="color"
    :disabled="disabled"
    :loading="loading"
    :text="text"
    :icon="icon"
    elevation="0"
    @click="handleClick"
    rounded
    :small="small"
    :large="large"
    :medium="medium"
    :plain="plain"
    :outlined="outlined"
    clearable
  >
    <v-icon v-if="iconLeft" left> {{ iconLeft }} </v-icon>
    <slot></slot>
    <v-icon v-if="iconRight" right> {{ iconRight }} </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "Button",
  props: {
    iconLeft: {
      type: String,
      default: "",
      validator: (value) => value.includes("mdi-") || value === "",
    },
    iconRight: {
      type: String,
      default: "",
      validator: (value) => value.includes("mdi-") || value === "",
    },
    color: {
      type: String,
      default: "brandPrimary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: true,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled && !this.loading) {
        this.$emit("click", event);
      }
    },
  },
};
</script>

<style scoped>
/* Custom button styles can go here */
.v-btn {
  color: white;
}

.v-card__actions > .v-btn.v-btn {
  padding: 0 16px !important;
}

/* 
  Only apply the shift if the button does NOT have text transformation classes 
  https://v2.vuetifyjs.com/en/styles/text-and-typography/#transform
*/
.v-btn:not(.text-none):not(.text-lowercase):not(.text-capitalize) ::v-deep .v-btn__content {
  transform: translate(0, 0.1em) !important;
}
</style>
